import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeave = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.58 8.833H4.719v-1h7.863L11.368 6.62l.702-.723 2.436 2.436-2.436 2.436-.702-.723 1.213-1.213Zm-3.445-2.59v-2.37a.2.2 0 0 0-.058-.148.2.2 0 0 0-.147-.057H2.539a.2.2 0 0 0-.148.057.2.2 0 0 0-.058.148v8.923a.2.2 0 0 0 .058.147.2.2 0 0 0 .147.058H8.93a.2.2 0 0 0 .147-.058.2.2 0 0 0 .058-.147v-2.372h1v2.372c0 .332-.118.616-.354.852A1.16 1.16 0 0 1 8.93 14H2.539c-.333 0-.617-.118-.853-.353a1.161 1.161 0 0 1-.353-.852V3.872c0-.333.118-.617.354-.852.235-.236.52-.353.851-.353H8.93c.332 0 .616.117.851.353.236.235.354.52.354.852v2.372h-1Z" })
});
export default SvgLeave;
